import React, { Component } from "react";
import PropTypes from "prop-types";
import { inject, observer } from "mobx-react";
import {
  Select,
  Loader,
  GridRow,
  GridColumn,
  Toastr,
} from "arv-reactcomponents";
import { toJS } from "mobx";
import NextButton from "../../NextButton";
import { RETURNS, CANCEL } from "npmlinks-constants";

const { RETURN_REASONS, RETURN_ELIGIBLE } = RETURNS;
const { CANCEL_REASONS, CANCEL_ELIGIBLE } = CANCEL;

@inject("ReturnStore", "AddressStore")
@observer
class ReturnOrCancelReasons extends Component {
  static getList(item) {
    return (
      <li className="nw-returnreason-reasonlist" key={item.id}>
        <span>{item.reason}</span>
      </li>
    );
  }

  static renderLoader() {
    return (
      <div className="nw-bodyoverlay">
        <div className="nw-bodyoverlay-loadercontainer">
          <Loader />
        </div>
      </div>
    );
  }

  constructor(props) {
    super(props);
    this.state = {
      comment: props.ReturnStore.comment,
      reasonId: props.ReturnStore.selectedReasonId,
    };

    this.componentStaticTexts =
      props.type === CANCEL_ELIGIBLE ? CANCEL_REASONS : RETURN_REASONS;

    this.selectionText = this.selectionText.bind(this);
    this.updateReasonChange = this.updateReasonChange.bind(this);
    this.handleCommentChange = this.handleCommentChange.bind(this);
    this.nextClick = this.nextClick.bind(this);
    this.getReturnDetails = this.getReturnDetails.bind(this);
    this.getCancelDetails = this.getCancelDetails.bind(this);
    this.getShippingAddress = this.getShippingAddress.bind(this);
  }

  componentDidMount() {
    const { type } = this.props;
    const reasons =
      Object.keys(toJS(this.props.ReturnStore.reasons)).length > 0;
    if (type === RETURN_ELIGIBLE && !reasons) {
      this.initReturn();
    } else if (type === CANCEL_ELIGIBLE && !reasons) {
      this.initCancel();
    }
  }

  initReturn() {
    this.getReturnDetails();
    this.getShippingAddress();
  }

  initCancel() {
    this.getCancelDetails();
  }

  get shouldEnableNextButton() {
    if (this.state.reasonId) return true;
    return false;
  }

  get loader() {
    return this.props.ReturnStore.loader;
  }

  getReturnDetails() {
    // To be removed after order details component is developed
    const { orderId, itemId } = this.props;
    this.props.ReturnStore.getReturnData(orderId, itemId)
      .then(() => {
        console.log("Got response from getReturnData API");
      })
      .catch(err => {
        Toastr.showToastr({
          className: "nwc-toastr-list-danger nw-toastr",
          message: RETURN_REASONS.ERROR_MESSAGE,
          timeout: 3000,
        });
        this.props.closeModal();
        console.log(err);
      });
  }

  getCancelDetails() {
    const { itemId } = this.props;
    this.props.ReturnStore.getCancelData(itemId)
      .then(() => {
        console.log("Got response from getCancelData API");
      })
      .catch(err => {
        Toastr.showToastr({
          className: "nwc-toastr-list-danger nw-toastr",
          message: RETURN_REASONS.ERROR_MESSAGE,
          timeout: 3000,
        });
        this.props.closeModal();
        console.log(err);
      });
  }

  getShippingAddress() {
    this.props.AddressStore.getUserAddresses(true)
      .then(() => {
        console.log("Got response from getCancelData API");
      })
      .catch(err => {
        Toastr.showToastr({
          className: "nwc-toastr-list-danger nw-toastr",
          message: RETURN_REASONS.ERROR_MESSAGE,
          timeout: 3000,
        });
        this.props.closeModal();
        console.log(err);
      });
  }

  selectionText(id) {
    const { REASON_SELECTION_PLACEHOLDER } = this.componentStaticTexts;
    const returnReasons = this.props.ReturnStore.reasons;
    const selectedReason = returnReasons.find(item => item.id === id);
    if (selectedReason) return selectedReason;
    return {
      id: null,
      reason: REASON_SELECTION_PLACEHOLDER,
    };
  }

  updateReasonChange(item) {
    if (item.id !== null) {
      this.setState({ reasonId: item.id });
    }
  }

  handleCommentChange(e) {
    e.preventDefault();
    this.setState({ comment: e.target.value });
  }

  nextClick(e) {
    e.preventDefault();
    this.props.ReturnStore.setReasons(this.state.reasonId, this.state.comment);
    this.props.next();
  }

  render() {
    const { reasonId, comment } = this.state;
    const { ReturnStore } = this.props;
    const selectedValue = this.selectionText(reasonId);
    const {
      TITLE,
      REASON_SELECTION_HEADER,
      COMMENT_HEADER,
      COMMENT_PLACEHOLDER,
    } = this.componentStaticTexts;
    const maxLength = RETURN_ELIGIBLE
      ? RETURN_REASONS.MAXLENGTH
      : CANCEL_REASONS.MAXLENGTH;
    return (
      <GridRow className="nw-returnmodes-container">
        {this.loader && ReturnOrCancelReasons.renderLoader()}
        <GridColumn>
          <h2 className="nw-return-title">{TITLE}</h2>
        </GridColumn>
        <GridColumn className="nw-return-wrapper">
          <div className="nw-returnreason-sub-header-reason">
            {REASON_SELECTION_HEADER}
          </div>
          <Select
            className="nw-returnreason-select"
            selectedValue={selectedValue}
            inpList={ReturnStore.reasons}
            getSelection={this.updateReasonChange}
            renderList={ReturnOrCancelReasons.getList}
            compareProp="reason"
          />

          <div className="nw-returnreason-sub-header-comments">
            {COMMENT_HEADER}
          </div>
          <textarea
            value={comment}
            onChange={this.handleCommentChange}
            placeholder={COMMENT_PLACEHOLDER}
            className="nw-returnreason-comment"
            maxLength={maxLength}
          />
        </GridColumn>
        <NextButton.component
          next={this.nextClick}
          disabled={!this.shouldEnableNextButton}
          className="nw-returns-nxtbtn"
        />
      </GridRow>
    );
  }
}

ReturnOrCancelReasons.defaultProps = {
  next: PropTypes.func,
};

ReturnOrCancelReasons.wrappedComponent.propTypes = {
  next: PropTypes.func,
  itemId: PropTypes.string.isRequired,
  orderId: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  closeModal: PropTypes.func.isRequired,
  AddressStore: PropTypes.shape({
    getUserAddresses: PropTypes.func.isRequired,
  }).isRequired,
  ReturnStore: PropTypes.shape({
    loader: PropTypes.bool,
    reasons: PropTypes.shape({}),
    comment: PropTypes.string,
    selectedReasonId: PropTypes.string,
    setReasons: PropTypes.func.isRequired,
    getReturnData: PropTypes.func.isRequired,
    getCancelData: PropTypes.func.isRequired,
  }).isRequired,
};

const getFinalComponent = component =>
  inject("ReturnStore", "AddressStore")(observer(component));

const ProjectComponent = {
  getFinalComponent,
  wrapper: ReturnOrCancelReasons.wrappedComponent,
  component: ReturnOrCancelReasons,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/component/ReturnComponent/ReturnOrCancelReasons/index.js